import { render, staticRenderFns } from "./StitchZoom.vue?vue&type=template&id=686dd40c&scoped=true&"
import script from "./StitchZoom.vue?vue&type=script&lang=js&"
export * from "./StitchZoom.vue?vue&type=script&lang=js&"
import style0 from "./StitchZoom.vue?vue&type=style&index=0&id=686dd40c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686dd40c",
  null
  
)

export default component.exports